import type { ReactNode } from 'react';

type AgeConfirmProps = {
  id: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  children: ReactNode;
};

export default function AgeConfirm({
  id,
  checked,
  onChange,
  children,
}: AgeConfirmProps) {
  return (
    <label
      htmlFor={id}
      className="flex items-start gap-2 text-xs leading-relaxed text-bk-muted"
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 shrink-0"
      />
      <span>{children}</span>
    </label>
  );
}
